function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { IconButton } from '@cbhq/cds-web/buttons/IconButton';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { legacyButtonRadius } from '../../../constants.js';
import { useDebounce } from '../../../hooks/useDebounce.js';
import { useGlobalMicrocopy } from '../../../providers/MicrocopyProvider.js';
import '../../../ui/Div/index.js';
import { Text } from '../../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../../ui/Div/Div.js';
const sanitizeSearchString = val => (Array.isArray(val) ? val[0] : val)?.toLowerCase().trim();
function SearchInput({
  term = '',
  onSearch = () => null,
  navigateOnTyping,
  setShowSearchBar,
  showSearchBar
}) {
  const _useState = useState(Array.isArray(term) ? term[0] : term),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  const microcopies = useGlobalMicrocopy();
  const _useDebounce = useDebounce(() => {
      if (!navigateOnTyping || !search) return;
      const sanitizedSearch = sanitizeSearchString(search);
      const sanitizedTerm = sanitizeSearchString(term);
      if (sanitizedSearch && sanitizedSearch?.length > 2 && sanitizedSearch !== sanitizedTerm) {
        onSearch(search);
      }
    }, 300, [search]),
    _useDebounce2 = _slicedToArray(_useDebounce, 2),
    cancel = _useDebounce2[1];
  useEffect(() => {
    const firstTerm = Array.isArray(term) ? term[0] : term;
    const sanitizedTerm = sanitizeSearchString(firstTerm);
    setSearch(current => {
      const sanitizedSearch = sanitizeSearchString(current);
      return sanitizedSearch !== sanitizedTerm ? firstTerm : current;
    });
  }, [term, setSearch]);
  const onEnter = () => {
    cancel();
    if (search) onSearch(search);
  };
  return /*#__PURE__*/jsxs(Div, {
    display: "block",
    position: "relative",
    borderRadius: "rounded",
    gap: {
      sm: 2,
      md: 3
    },
    maxWidth: {
      sm: '100%',
      md: 700
    },
    css: {
      '> button': {
        top: -2,
        right: -11,
        position: 'absolute'
      }
    },
    children: [/*#__PURE__*/jsxs(Text, {
      variant: "label2",
      display: "inherit",
      position: "relative",
      css: {
        input: {
          height: 36,
          width: '100%',
          paddingLeft: 24,
          paddingRight: 8,
          borderRadius: legacyButtonRadius,
          '&:focus-visible': {
            outline: 'none !important'
          }
        },
        '> div': {
          top: 11,
          left: 0,
          position: 'absolute !important'
        }
      },
      children: [/*#__PURE__*/jsx(Icon, {
        name: "search",
        size: "s",
        color: "primary"
      }), /*#__PURE__*/jsx("input", {
        autoFocus: true,
        value: search
        // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
        ,

        onChange: e => setSearch(e.target.value)
        // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
        ,

        onKeyDown: e => e.key === 'Enter' && onEnter(),
        placeholder: microcopies.global.searchForTopicOrArticle
      })]
    }), showSearchBar && setShowSearchBar && /*#__PURE__*/jsx(IconButton, {
      transparent: true,
      name: "close",
      variant: "foregroundMuted"
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
      ,

      onPress: () => setShowSearchBar(false)
    })]
  });
}
export { SearchInput };
//# sourceMappingURL=SearchInput.js.map
